import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const columnsCss = ":host{--gap:0px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:row;flex-wrap:wrap;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([gutter=xs]){--gap:0.0625rem;gap:.25rem}:host([gutter=sm]){--gap:0.125rem;gap:.5rem}:host([gutter=md]){--gap:0.25rem;gap:1rem}:host([gutter=lg]){--gap:0.375rem;gap:1.5rem}:host([gutter=xl]){--gap:0.5rem;gap:2rem}";
const WuiColumnsStyle0 = columnsCss;

const WuiColumns$1 = /*@__PURE__*/ proxyCustomElement(class WuiColumns extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.gutter = undefined;
    }
    render() {
        return (h(Host, { key: 'e3856c8be3c4045bd584ededee99943c7bbd31f1' }, h("slot", { key: 'd8d90a38a7791ee160e158863f561466eda9ffad' })));
    }
    static get style() { return WuiColumnsStyle0; }
}, [1, "wui-columns", {
        "gutter": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-columns"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-columns":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiColumns$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiColumns = WuiColumns$1;
const defineCustomElement = defineCustomElement$1;

export { WuiColumns, defineCustomElement };

//# sourceMappingURL=wui-columns.js.map